module.exports = __webpack_public_path__ + "google.7928e3de60b9e1ae2b16.png";


//////////////////
// WEBPACK FOOTER
// E:/Java/ResumeAngular/resume/src/assets/images/google.png
// module id = ../../../../../src/assets/images/google.png
// module chunks = main